import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { SectionWithAccordion } from 'views/Infrastructure/accordionData'

import AccordionSection from '../AccordionSection'

import CollectionLibrariesImage from './CollectionLibrariesImage'

const data = {
  anchorId: `libraries`,
  overline: `Collection`,
  heading: `Libraries`,
  description: `You need to collect customer data from your website and mobile apps tens of thousands of times per second. It should never crash and always work reliably. Here’s how we do it…`,
  link: `https://github.com/segmentio/analytics.js`,
  linkText: `segmentio/analytics.js (4,500 stars)`,
  accordionSection: SectionWithAccordion.LIBRARIES,
}

const CollectionLibraries: FC<PropsWithChildren<unknown>> = () => {
  const { anchorId, overline, heading, description, link, linkText, accordionSection } = data
  return (
    <Wrapper id={anchorId}>
      <SectionBase variant="2Col" copyVariant="wide">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Overline>{overline}</CopyText.Overline>
            <CopyText.Heading>{heading}</CopyText.Heading>
            <CopyText.Description tag="div">
              <CopyTextDescriptionSection>{description}</CopyTextDescriptionSection>
              <CopyTextDescriptionSection>
                <Typography variant="pLarge">
                  <a href={link}>{linkText}</a>
                </Typography>
              </CopyTextDescriptionSection>
              <AccordionSection section={accordionSection} />
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <CollectionLibrariesImage />
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const CopyTextDescriptionSection = styled.div`
  margin-bottom: 32px;
`

const Wrapper = styled.section`
  display: grid;
`

export default CollectionLibraries
